'use client'
import { createContext } from 'react'

export const ConfigContext = createContext({})
